import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
	Avatar,
	Badge,
	Box,
	Divider,
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
	Paper,
	Typography
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import {
	AccountBalanceWalletOutlined,
	ArrowForwardIos,
	AttachMoney,
	Contrast,
	DarkMode,
	EditNote,
	LightMode,
	Logout,
	Person
} from '@mui/icons-material';
import { DARK_THEME, LIGHT_THEME } from '../../../../Redux/Types/themeTypes';

function AccountMenuDropdown({
	anchorEl,
	handleMenu,
	handleClose,
	handleNavigation,
	billingSelector,
	handleThemeSwitch,
	handleLogout
}) {
	const [anchorTh, setAnchorTh] = useState(null);
	const { userDetails } = useSelector((state) => state.userReducer);
	const handleThemeMenuOpen = (event) => {
		setAnchorTh(event.currentTarget);
	};

	const handleThemeMenuClose = () => {
		setAnchorTh(null);
	};
	return (
		<Box aria-controls="menu-appbar" className="appBar-menu-container">
			<MenuIcon
				fontSize="small"
				className="appBar-menuicon"
				cy-data="menu-wrapper"
				onClick={handleMenu}
			/>
			<Badge
				overlap="circular"
				badgeContent="2"
				color="secondary"
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				variant="dot"
				onClick={handleMenu}
				sx={{ cursor: 'pointer' }}
			>
				<Avatar
					alt="user avatar"
					className="appBar-avatar"
					src={userDetails?.personalInformation?.profilePhoto}
				>
					{userDetails?.firstName
						? userDetails?.firstName[0]
						: userDetails?.userName?.split(' ')[0][0]}
				</Avatar>
			</Badge>
			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				transformOrigin={{ horizontal: 'center', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				sx={{ marginTop: 2 }}
				// className="appBar-dropdown-menu"
			>
				<Paper elevation={0} sx={{ width: 200 }}>
					<MenuItem className="email-menu_item">
						<Typography className="inter-style-thin" color="text.secondary">
							{userDetails?.email}
						</Typography>
					</MenuItem>
					<Divider className="email-menu_item" />
					<MenuItem
						onClick={() => {
							handleNavigation({
								name: 'profile',
								link: `/profile/${userDetails.userName}`
							});
						}}
						cy-data="app-bar-menu-item"
					>
						<ListItemIcon>
							<Person fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
						>
							Profile
						</ListItemText>
					</MenuItem>
					<MenuItem
						onClick={() => {
							handleNavigation({
								name: 'edit-profile',
								link: `/user-profile`
							});
						}}
						cy-data="app-bar-menu-item"
					>
						<ListItemIcon>
							<EditNote fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
						>
							Edit Profile
						</ListItemText>
					</MenuItem>
					<MenuItem
						onClick={() => {
							handleNavigation({
								name: 'subscription',
								link: `/subscription`
							});
						}}
						cy-data="app-bar-menu-item"
					>
						<ListItemIcon>
							<AttachMoney fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
						>
							Subscription
						</ListItemText>
					</MenuItem>
					<Divider />
					<MenuItem
						onClick={() => {
							handleNavigation({
								name: 'account-details',
								link: `/account-details`
							});
						}}
						cy-data="app-bar-menu-item"
					>
						<ListItemIcon>
							<AccountBalanceWalletOutlined fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
						>
							Credits: {Math.round(billingSelector.qbraidCredits)}
						</ListItemText>
					</MenuItem>
					<Divider />
					<MenuItem
						onClick={handleThemeMenuOpen}
						sx={{
							justifyContent: 'space-between',
							alignItems: 'center'
						}}
						// className="appBar-dropdown-menu"
						value="theme"
					>
						<ListItemIcon>
							<Contrast fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
						>
							Theme
						</ListItemText>
						<ArrowForwardIos size="small" fontSize="inherit" />
					</MenuItem>
					<Menu
						anchorEl={anchorTh}
						transformOrigin={{ horizontal: 'right', vertical: 'top' }}
						anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
						open={Boolean(anchorTh)}
						onClose={handleThemeMenuClose}
						onClick={handleThemeMenuClose}
						// className="appBar-dropdown-menu"
					>
						<MenuItem onClick={() => handleThemeSwitch(LIGHT_THEME)}>
							<ListItemIcon>
								<LightMode fontSize="small" />
							</ListItemIcon>
							<ListItemText
								primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
							>
								Light theme
							</ListItemText>
						</MenuItem>
						<MenuItem onClick={() => handleThemeSwitch(DARK_THEME)}>
							<ListItemIcon>
								<DarkMode fontSize="small" />
							</ListItemIcon>
							<ListItemText
								primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
							>
								Dark theme
							</ListItemText>
						</MenuItem>
					</Menu>
					<MenuItem onClick={handleLogout} cy-data="logout" id="logoutTarget">
						<ListItemIcon>
							<Logout fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
						>
							Logout
						</ListItemText>
					</MenuItem>
				</Paper>
			</Menu>
		</Box>
	);
}

export default AccountMenuDropdown;
